import {
  ADVANCED_SEARCH_ERROR,
  ADVANCED_SEARCH_RECEIVE_CAR_MODEL,
  ADVANCED_SEARCH_UPDATE_PAYLOAD,
  ADVANCED_SEARCH_DIMENSIONS,
  ADVANCED_SEARCH_SET_IS_LOADING_URL,
} from '../constants';

const defaultState = {
  activeTab: ADVANCED_SEARCH_DIMENSIONS,
  isLoading: false,
  isLoadingUrl: false,
  model: {},
  error: null,
};

export const advancedSearch = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADVANCED_SEARCH_RECEIVE_CAR_MODEL: {
      const prev = state.model?.carModel || {};
      // If brand changed, clear downstream state to avoid stale data
      const brandChanged = payload.selectedBrandSystemId !== prev.selectedBrandSystemId;
      const base = brandChanged ? { brands: prev.brands } : prev;
      return {
        ...state,
        model: { ...state.model, carModel: { ...base, ...payload } },
      };
    }

    case ADVANCED_SEARCH_UPDATE_PAYLOAD:
    case ADVANCED_SEARCH_ERROR:
    case ADVANCED_SEARCH_SET_IS_LOADING_URL:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
